import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  type HttpOptions,
  InMemoryCache, 
  gql,
} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { RetryLink } from '@apollo/client/link/retry'

const baseConfig: HttpOptions = {
  uri: '/api/graphql',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? 'NO CSRF TOKEN',
  }
}

const ErrorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const metaData = {
    operationName: operation?.operationName ?? 'undefined',
    variables: operation?.variables,
    graphQLErrors: graphQLErrors?.map((e) => e.message),
  }
  const error = networkError ?? new Error('Unknown GraphQL error')
  console.error(`🚨 GraphQL error: ${error.message}`, metaData)
})

const AddOperationNameLink = new ApolloLink((operation, forward) => {
  const { operationName } = operation
  if (operationName) {
    try {
      const path = operation.getContext().uri || baseConfig.uri
      const urlObj = new URL(`${window.location.origin}/${path}`)
      urlObj.searchParams.set('_op', operationName)
      operation.setContext({ uri: urlObj.href })
    } catch (e) {}
  }
  return forward(operation)
})

const RetryRequestLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 3,
  },
})

const BaseLink = new HttpLink(baseConfig)


const client = new ApolloClient({
  link: ApolloLink.from([
    ErrorLink,
    AddOperationNameLink,
    RetryRequestLink,
    BaseLink,
  ]),
  cache: new InMemoryCache(),
  connectToDevTools: true,
})

export { gql, client }
